import { Stack, Typography } from "@mui/material";
import { CustomCellRendererProps } from "ag-grid-react";
import React, { useMemo } from "react";
import { globalTheme } from "../../styles";
import { CustomerProfileIcon } from "../Icon";
import { EmailOutlined, PhonelinkLockOutlined } from "@mui/icons-material";

// Memoise cell level component to avoid unnecessaru re-renders. This helps enhancing performance improvements
export const CustomerDataCell = React.memo((params: CustomCellRendererProps) => {
  const { data } = params;

  const localDateTime = new Date(data.appImportDateTime).toLocaleString();
  return useMemo(
    () => (
      <Stack>
        <Stack direction="row" spacing={2} alignItems="center">
          <CustomerProfileIcon />
          <Stack>
            <Stack direction="row" spacing={0.5}>
              {(data.shippingFirstName || data.shippingLastName || data?.shippingCompanyName) && (
                <Typography variant="body2" color={globalTheme.primaryColor}>
                  {`${data.shippingFirstName || ""} ${data.shippingLastName || ""}${
                    data.shippingCompanyName ? `, ${data.shippingCompanyName}` : ""
                  }`}
                </Typography>
              )}
            </Stack>
            <Stack direction="row" spacing={0.5}>
              {(data.shippingAddressLine1 || data?.shippingAddressLine2) && (
                <Typography variant="caption" color={globalTheme.primaryColor}>
                  {`${data.shippingAddressLine1 || ""}${data.shippingAddressLine2 ? `, ${data.shippingAddressLine2}` : ""}`}
                </Typography>
              )}
            </Stack>

            <Stack direction="row" spacing={0.5}>
              {data.shippingCity && (
                <Typography variant="caption" color={globalTheme.primaryColor}>
                  {`${data.shippingCity || ""},`}
                </Typography>
              )}
              {data.shippingStateOrProvince && (
                <Typography variant="caption" color={globalTheme.primaryColor}>
                  {`${data.shippingStateOrProvince || ""},`}
                </Typography>
              )}

              {(data.shippingCountry || data.shippingPostalCode) && (
                <Typography variant="caption" color={globalTheme.primaryColor}>
                  {` ${data.shippingCountry || ""}, ${data.shippingPostalCode || ""}`}
                </Typography>
              )}
            </Stack>

            {(data.shippingDaytimePhone || data.buyerEmailAddress) && (
              <Stack direction="row" alignItems="center" spacing={1}>
                {data.shippingDaytimePhone && (
                  <Typography variant="caption" color={globalTheme.primaryColor} sx={{ display: "flex", alignItems: "center" }}>
                    <PhonelinkLockOutlined sx={{ fontSize: 14, marginRight: 0.5 }} /> {data.shippingDaytimePhone}
                  </Typography>
                )}
                {data.buyerEmailAddress && (
                  <Typography variant="caption" color={globalTheme.primaryColor} sx={{ display: "flex", alignItems: "center" }}>
                    <EmailOutlined sx={{ fontSize: 14, marginLeft: 1, marginRight: 0.5 }} /> {data.buyerEmailAddress}
                  </Typography>
                )}
              </Stack>
            )}

            {data?.siteName && (
              <Typography variant="body2">
                <strong style={{ color: "#01168e", fontSize: "0.7rem" }}>{data?.siteName}</strong>
                {" - "}
                {localDateTime}
              </Typography>
            )}
          </Stack>
        </Stack>
      </Stack>
    ),
    [data]
  );
});
